/**
 * @generated SignedSource<<aa17a8a95631f7d22f67939b753198a5>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftPdpHistoryItem_nftItemHistoryEvent$data = {
  readonly __typename: string;
  readonly auction?: {
    readonly endedConversionRates: {
      readonly rates: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"useEtherConversion_etherRates">;
      } | null> | null;
    } | null;
  } | null;
  readonly auctionCreator?: {
    readonly " $fragmentSpreads": FragmentRefs<"NftPdpUserLink_ethereumAddress">;
  } | null;
  readonly bidAmount?: {
    readonly ether: string | null;
  } | null;
  readonly bidder?: {
    readonly address: string | null;
    readonly publicProfileUrl: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"NftPdpUserLink_ethereumAddress">;
  } | null;
  readonly canceledBy?: {
    readonly " $fragmentSpreads": FragmentRefs<"NftPdpUserLink_ethereumAddress">;
  } | null;
  readonly from?: {
    readonly address: string | null;
    readonly isAddressZero: boolean | null;
    readonly " $fragmentSpreads": FragmentRefs<"NftPdpUserLink_ethereumAddress">;
  } | null;
  readonly ids?: ReadonlyArray<string | null> | null;
  readonly isPaused?: boolean | null;
  readonly operator?: {
    readonly address: string | null;
  } | null;
  readonly reservePrice?: {
    readonly ether: string | null;
  } | null;
  readonly timestamp: string | null;
  readonly to?: {
    readonly address: string | null;
    readonly isAddressZero: boolean | null;
    readonly " $fragmentSpreads": FragmentRefs<"NftPdpUserLink_ethereumAddress">;
  } | null;
  readonly tokenId?: string | null;
  readonly transactionHash: string | null;
  readonly value: {
    readonly ether: string | null;
  } | null;
  readonly valueArg?: number | null;
  readonly values?: ReadonlyArray<string | null> | null;
  readonly winningBid?: {
    readonly ether: string | null;
  } | null;
  readonly winningBidder?: {
    readonly address: string | null;
    readonly publicProfileUrl: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"NftPdpUserLink_ethereumAddress">;
  } | null;
  readonly " $fragmentType": "NftPdpHistoryItem_nftItemHistoryEvent";
};
export type NftPdpHistoryItem_nftItemHistoryEvent$key = {
  readonly " $data"?: NftPdpHistoryItem_nftItemHistoryEvent$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpHistoryItem_nftItemHistoryEvent">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "ether",
    "storageKey": null
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v2 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "NftPdpUserLink_ethereumAddress"
},
v3 = [
  (v1/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isAddressZero",
    "storageKey": null
  },
  (v2/*:: as any*/)
],
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "EthereumAddressType",
  "kind": "LinkedField",
  "name": "from",
  "plural": false,
  "selections": (v3/*:: as any*/),
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "NftAuction",
  "kind": "LinkedField",
  "name": "auction",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NftConversionRateEvent",
      "kind": "LinkedField",
      "name": "endedConversionRates",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EtherRates",
          "kind": "LinkedField",
          "name": "rates",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "useEtherConversion_etherRates"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = [
  (v2/*:: as any*/)
],
v7 = [
  (v1/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "publicProfileUrl",
    "storageKey": null
  },
  (v2/*:: as any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "EthereumAddressType",
  "kind": "LinkedField",
  "name": "to",
  "plural": false,
  "selections": (v3/*:: as any*/),
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "EthereumAddressType",
  "kind": "LinkedField",
  "name": "operator",
  "plural": false,
  "selections": [
    (v1/*:: as any*/)
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftPdpHistoryItem_nftItemHistoryEvent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timestamp",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "transactionHash",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EtherAmount",
      "kind": "LinkedField",
      "name": "value",
      "plural": false,
      "selections": (v0/*:: as any*/),
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v4/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "EthereumAddressType",
          "kind": "LinkedField",
          "name": "to",
          "plural": false,
          "selections": [
            (v1/*:: as any*/),
            (v2/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "NftItemHistoryTransferEvent",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v5/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "EtherAmount",
          "kind": "LinkedField",
          "name": "reservePrice",
          "plural": false,
          "selections": (v0/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "EthereumAddressType",
          "kind": "LinkedField",
          "name": "auctionCreator",
          "plural": false,
          "selections": (v6/*:: as any*/),
          "storageKey": null
        }
      ],
      "type": "NftItemHistoryAuctionCreatedEvent",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v5/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "EtherAmount",
          "kind": "LinkedField",
          "name": "bidAmount",
          "plural": false,
          "selections": (v0/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "EthereumAddressType",
          "kind": "LinkedField",
          "name": "bidder",
          "plural": false,
          "selections": (v7/*:: as any*/),
          "storageKey": null
        }
      ],
      "type": "NftItemHistoryAuctionBidEvent",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isPaused",
          "storageKey": null
        }
      ],
      "type": "NftItemHistoryAuctionPausedEvent",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v5/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "EtherAmount",
          "kind": "LinkedField",
          "name": "winningBid",
          "plural": false,
          "selections": (v0/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "EthereumAddressType",
          "kind": "LinkedField",
          "name": "winningBidder",
          "plural": false,
          "selections": (v7/*:: as any*/),
          "storageKey": null
        }
      ],
      "type": "NftItemHistoryAuctionEndedEvent",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EthereumAddressType",
          "kind": "LinkedField",
          "name": "canceledBy",
          "plural": false,
          "selections": (v6/*:: as any*/),
          "storageKey": null
        }
      ],
      "type": "NftItemHistoryAuctionCanceledEvent",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tokenId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "valueArg",
          "storageKey": null
        },
        (v4/*:: as any*/),
        (v8/*:: as any*/),
        (v9/*:: as any*/)
      ],
      "type": "NftItemHistoryTransferSingleEvent",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "values",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ids",
          "storageKey": null
        },
        (v4/*:: as any*/),
        (v8/*:: as any*/),
        (v9/*:: as any*/)
      ],
      "type": "NftItemHistoryTransferBatchEvent",
      "abstractKey": null
    }
  ],
  "type": "NftItemHistoryEvent",
  "abstractKey": "__isNftItemHistoryEvent"
};
})();

(node as any).hash = "a2fa8d72ac7ca7ee17263032aa88643a";

export default node;
